import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Section } from "pax-ui/components";
import { ProductAgnosticCustomRouteData } from "src/app/shared/routes/shared/shared-route.constant";
import { RouteDataService } from "src/app/shared/services/route-data.service";

// TODO: Ask chris how this page should look like (the current state is only a placeholder implementation)
@Component({
  selector: "app-application-has-expired",
  imports: [Section],
  templateUrl: "./application-has-expired.html",
  styleUrls: ["./application-has-expired.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationHasExpiredPage {
  productAgnosticCustomRouteData: ProductAgnosticCustomRouteData;

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _routeDataService: RouteDataService,
  ) {
    this.productAgnosticCustomRouteData =
      this._routeDataService.getProductAgnosticCustomRouteData(
        this._activatedRoute,
      );
  }
}
